export default (o) => Object.keys(o).map((k) => o[k]);